import { UntypedFormGroup } from '@angular/forms';
import { Contact } from '@app/model/contact.model';
import { Address } from '../../model/address.model';

export const isValidAddress = (address: Address) => !!address && !!address.postCode && !!address.line1;

export const getAddressError = (form: UntypedFormGroup, address: string[], label: string[]): string => {
    let error = '';
    let errorCount = 0;
    address.forEach((a, i) => {
        if (form.controls[a]) {
            if (form.controls[a].getError('invalidValue') != null || form.controls[a].getError('required')) {
                if (errorCount >= 1) {
                    error += ', ';
                }
                error += label[i] + ' must have a valid value';
                errorCount += 1;
            }
        }
    });
    return error;
};

export const isEmpty = (string: string): boolean => (!string || string.length === 0);

export const validateContact = (contact: Contact): {isDeliveryAddressValid: boolean; isInvoiceAddressValid: boolean} => {
    const isAddressValid = { isDeliveryAddressValid: true, isInvoiceAddressValid: true };
    if (contact.deliveryAddress != null) {
        isAddressValid.isDeliveryAddressValid = validateAddress(contact.deliveryAddress);
    }
    if (contact.postalAddress != null) {
        isAddressValid.isInvoiceAddressValid = validateAddress(contact.postalAddress);
    }
    return isAddressValid;
};

export const validateAddress = (address: Address): boolean => {
    if (address == null) {
        return false;
    }
    if (isEmpty(address.line1) || isEmpty(address.townOrCity) || isEmpty(address.postCode) || isEmpty(address.country)) {
        return false;
    }
    return true;
};
